<template>
  <b-card v-if='project && project != null &&
  (project.approvalStatus === "Approved" || project.approvalStatus === "Cancelled" || project.approvalStatus === "Completed")' class="col-6">
     <LoadingSpinner v-if='projectLoading || projectSnapshotDraftLoading' message ='Loading data' size = '1x'/>
     <div v-else>
      <div class="row">
        <div class="col-6 details-label">
          <a v-b-toggle="'landownerCostShare'" class="c-pointer">
            <b-icon icon='caret-right-fill' class="when-closed" />
            <b-icon icon='caret-down-fill' class="when-opened" />
            <span>Cost Share</span>
          </a>
        </div>
        <template v-if="budgetTotalSnapshotAmount === 0">
          <div class="col-6 text-right">
            N/A
          </div>
        </template>
        <template v-else>
          <div v-if="budgetSnapshotCostSharePercent === 0" class="col-3 text-right text-primary">
            (0%)
          </div>
          <div v-else class="col-3 text-right text-primary">
            ({{ budgetSnapshotCostSharePercent | toPercent }}%)
          </div>
          <div class="col-3 text-right">
            {{ budgetSnapshotTotalCostShare | toCurrency }}
          </div>
        </template>
      </div>
      <b-collapse id="landownerCostShare">
        <div class="row">
          <div class="col-5 offset-1">Base Cost:</div>
          <div class="col-6 text-right">
            {{ budgetSnapshotBaseCostShare | toCurrency }}
          </div>
        </div>
        <div class="row">
          <div class="col-5 offset-1">Contingency Cost:</div>
          <div class="col-6 text-right">
            {{ budgetSnapshotContingencyCostShare | toCurrency }}
          </div>
        </div>
      </b-collapse>
      <hr color="black" size="20">
      <div v-for="fundingSource in fundingSourceSnapshotSummaries.values()"
        :key = "fundingSource.name">
        <div class="row">
          <div class="col-6 details-label">
            <a v-b-toggle="`${fundingSource.name.replaceAll(' ','')}-details`" class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              {{ fundingSource.name }}
            </a>
          </div>
          <template v-if="budgetTotalSnapshotAmount === 0">
            <div class="col-6 text-right">
              N/A
            </div>
          </template>
          <template v-else>
            <div class="col-3 text-right text-primary">
              ({{ getFundingSourceSnapshotPercentOfTotal(fundingSource) | toPercent }}%)
            </div>
            <div class="col-3 text-right">
              {{ getFundingSourceSnapshotTotal(fundingSource) | toCurrency }}
            </div>
          </template>
        </div>
        <b-collapse :id="`${fundingSource.name.replaceAll(' ','')}-details`">
          <div class="row">
            <div class="col-5 offset-1">Base Cost:</div>
            <div class="col-6 text-right">
              {{ fundingSource.baseCost | toCurrency }}
            </div>
          </div>
          <div class="row" >
            <div class="col-5 offset-1">Contingency Cost:</div>
            <div class="col-6 text-right" v-if="fundingSource.contingencyCost">
              {{ fundingSource.contingencyCost | toCurrency }}
            </div>
            <div class="col-6 text-right" v-else>
              N/A
            </div>
          </div>
          <div class="row">
            <div class="col-5 offset-1">Adjustment Amount:</div>
            <div class="col-6 text-right" v-if="fundingSource.adjustmentAmount">
              {{ fundingSource.adjustmentAmount | toCurrency }}
            </div>
            <div class="col-6 text-right" v-else>
              N/A
            </div>
          </div>
        </b-collapse>
        <hr/>
      </div>
      <div class="row summary-line">
        <div class="col-6 details-label summary-line-label">
          <span>Total Project Cost</span>
        </div>
        <div class="col-6 text-right normal-title">
          <template v-if="budgetTotalSnapshotAmount === 0">
            N/A
          </template>
          <template v-else>
            {{ budgetTotalSnapshotAmount | toCurrency }}
          </template>
        </div>
      </div>
    </div>
  </b-card>

  <b-card v-else class="col-6">
    <LoadingSpinner v-if='projectLoading || projectSnapshotDraftLoading' message ='Loading data' size = '1x'/>
    <div v-else>
      <div class="row">
        <div class="col-6 details-label">
          <a v-b-toggle="'landownerCostShare'" class="c-pointer">
            <b-icon icon='caret-right-fill' class="when-closed" />
            <b-icon icon='caret-down-fill' class="when-opened" />
            <span>Cost Share</span>
          </a>
        </div>
        <template v-if="budgetTotalAmount === 0">
          <div class="col-6 text-right">
            N/A
          </div>
        </template>
        <template v-else>
          <div v-if="budgetCostSharePercent === 0" class="col-3 text-right text-primary">
            (0%)
          </div>
          <div v-else class="col-3 text-right text-primary">
            ({{ budgetCostSharePercent | toPercent }}%)
          </div>
          <div class="col-3 text-right">
            {{ budgetTotalCostShare | toCurrency }}
          </div>
        </template>
      </div>
      <b-collapse id="landownerCostShare">
        <div class="row">
          <div class="col-5 offset-1">Base Cost:</div>
          <div class="col-6 text-right">
            {{ budgetBaseCostShare | toCurrency }}
          </div>
        </div>
        <div class="row">
          <div class="col-5 offset-1">Contingency Cost:</div>
          <div class="col-6 text-right">
            {{ budgetContingencyCostShare | toCurrency }}
          </div>
        </div>
      </b-collapse>
      <hr color="black" size="20">
      <div v-for="fundingSource in fundingSourceSummaries.values()"
        :key = "fundingSource.name">
        <div class="row">
          <div class="col-6 details-label">
            <a v-b-toggle="`${fundingSource.name.replaceAll(' ','')}-details`" class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              {{ fundingSource.name }}
            </a>
          </div>
          <template v-if="budgetTotalAmount === 0">
            <div class="col-6 text-right">
              N/A
            </div>
          </template>
          <template v-else>
            <div class="col-3 text-right text-primary">
              ({{ getFundingSourcePercentOfTotal(fundingSource) | toPercent }}%)
            </div>
            <div class="col-3 text-right">
              {{ getFundingSourceTotal(fundingSource) | toCurrency }}
            </div>
          </template>
        </div>
        <b-collapse :id="`${fundingSource.name.replaceAll(' ','')}-details`">
          <div class="row">
            <div class="col-5 offset-1">Base Cost:</div>
            <div class="col-6 text-right">
              {{ fundingSource.baseCost | toCurrency }}
            </div>
          </div>
          <div class="row" >
            <div class="col-5 offset-1">Contingency Cost:</div>
            <div class="col-6 text-right" v-if="fundingSource.contingencyCost">
              {{ fundingSource.contingencyCost | toCurrency }}
            </div>
            <div class="col-6 text-right" v-else>
              N/A
            </div>
          </div>
          <div class="row">
            <div class="col-5 offset-1">Adjustment Amount:</div>
            <div class="col-6 text-right" v-if="fundingSource.adjustmentAmount">
              {{ fundingSource.adjustmentAmount | toCurrency }}
            </div>
            <div class="col-6 text-right" v-else>
              N/A
            </div>
          </div>
        </b-collapse>
        <hr/>
      </div>
      <div class="row summary-line">
        <div class="col-6 details-label summary-line-label">
          <span>Total Project Cost</span>
        </div>
        <div class="col-6 text-right normal-title">
          <template v-if="budgetTotalAmount === 0">
            N/A
          </template>
          <template v-else>
            {{ budgetTotalAmount | toCurrency }}
          </template>
        </div>
      </div>
    </div>
  </b-card>

</template>
<script>
import { mapState } from 'vuex';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';
import FiscalYear from '@/mixins/fiscalYear';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'FundingBreakdown',
  components: {
    LoadingSpinner,
  },
  mixins: [
    ProjectTotalsCalculator,
    FiscalYear,
  ],
  computed: {
    ...mapState('Project', {
      project: (state) => state.project,
      projectLoading: (state) => state.projectLoading,
      projectSnapshotDraftLoading: (state) => state.projectSnapshotDraftLoading,
      projectSnapshotDraft: (state) => state.projectSnapshotDraft,
    }),
  },
};
</script>
